import { render, staticRenderFns } from "./ApproveHistoryLine.vue?vue&type=template&id=188c5d65&scoped=true&"
import script from "./ApproveHistoryLine.vue?vue&type=script&lang=js&"
export * from "./ApproveHistoryLine.vue?vue&type=script&lang=js&"
import style0 from "./ApproveHistoryLine.vue?vue&type=style&index=0&id=188c5d65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c5d65",
  null
  
)

export default component.exports